module.exports = __webpack_public_path__ + "static/bright-ideas-icon-b0b7683989fc682bd3fe6ead041de0cf.svg";